import { render, staticRenderFns } from "./freephoto.vue?vue&type=template&id=31827504&"
import script from "./freephoto.vue?vue&type=script&lang=js&"
export * from "./freephoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports